import { useCallback } from 'react';

import { Address, GiftCard, OrderReceipt } from 'olo-service';
import { CheckoutCart, formatRequest } from 'olo-service/Order';
import { useColoRequest } from './useColoRequest';
import { isSlug } from './isSlug';
import { heapTrack } from 'util/Analytics';
import { ServiceTypeData } from 'hooks/context/serviceType/models';

type SubmitOrderRequest = CheckoutCart & { paymentToken?: string, type: string | undefined, typeMetadata?: ServiceTypeData, scheduledTime: number | undefined, appliedGiftCards?: GiftCard[], perkUuid?:string, address?: Address };

export function usePostOrdersRequest(merchantId?: string, sessionId?: string) {
  const [, request] = useColoRequest(({ paymentToken, type, scheduledTime,appliedGiftCards, ...cart }: SubmitOrderRequest, captchaToken?: RecaptchaToken) => merchantId && ({
    method: 'POST',
    url: `${merchantId}/orders`,
    headers: {
      'X-Captcha-Token': captchaToken,
      'X-Clover-Customer-Auth': sessionId
    },
    params: { slug: isSlug(merchantId) },
    data: {
      ...formatRequest(cart),
      paymentToken,
      type,
      scheduledTime,
      ...(!!appliedGiftCards?.length && { giftSources:appliedGiftCards })
    }
  }), [merchantId]);

  return useCallback(async (cart: SubmitOrderRequest, captchaToken?: RecaptchaToken) => {
    const response = await request<OrderReceipt>(cart, captchaToken);
    if (!response) throw new Error('PostOrders returned an empty response');

    // track the giftcard load amount for each giftcard
    cart.giftCards.forEach(({ amount }) => heapTrack('gift-card-load', { amount }));

    return response;
  }, [request]);
}
